import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useStProjectWaveform(projectId) {
    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}/waveform`, {revalidateOnFocus: false})
    return {
        stProjectWaveform: data,
        mutateStProjectWaveform: mutate,
        isLoadingStProjectWaveform: !error && !data,
        isErrorStProjectWaveform: error
    }
}